<header>
  <div class="top-bar">
    <div class="top-bar-inner">
      <div class="logo-section">
        <a class="brand-link" [routerLink]="PublicPaths.Login" aria-label="MyFreight360 home">
          <img class="brand-logo" src="assets/brand-logo-D5ClalOM.svg" alt="MyFreight360" />
        </a>
      </div>

      @if (showMainNavbar()) {
        <nav class="nav-section" aria-label="Primary navigation">
          @if (canAccessDashboard()) {
            <a
              class="nav-link"
              [routerLink]="UserPaths.Dashboard"
              [class.nav-link-active]="isRouteActive(UserPaths.Dashboard)"
            >
              {{ 'headerNav.dashboard' | translate }}
            </a>
          }

          @for (module of visibleModules(); track module.labelKey) {
            <a
              class="nav-link"
              [routerLink]="module.routerLink"
              [class.nav-link-active]="isRouteActive(module.routerLink)"
            >
              {{ module.labelKey | translate }}
            </a>
          }

          @if (canAccessAdminMenu()) {
            <div class="settings-dropdown" [class.open]="showSettingsMenu()">
              <button
                class="nav-link nav-button admin-button"
                [class.nav-link-active]="isAdminRouteActive()"
                type="button"
                aria-label="Settings"
                (click)="toggleSettingsMenu()"
              >
                <span>{{ 'headerNav.administration' | translate }}</span>
                <i class="pi pi-chevron-down"></i>
              </button>

              @if (showSettingsMenu()) {
                <div class="settings-menu-panel" role="menu">
                  @for (item of visibleAdminMenuItems(); track item.label) {
                    <a
                      class="settings-menu-item"
                      [routerLink]="item.routerLink"
                      (click)="closeMenus()"
                    >
                      {{ item.label | translate }}
                    </a>
                  }
                </div>
              }
            </div>
          }
        </nav>

        <div class="actions-section">
          <!-- <div
            class="language-switch"
            role="group"
            [attr.aria-label]="'headerNav.language.ariaLabel' | translate"
          >
            <button
              class="lang-button"
              type="button"
              [class.lang-button-active]="isLanguageActive('en')"
              [attr.aria-pressed]="isLanguageActive('en')"
              (click)="changeLanguage('en')"
            >
              {{ 'headerNav.language.en' | translate }}
            </button>

            <button
              class="lang-button"
              type="button"
              [class.lang-button-active]="isLanguageActive('he')"
              [attr.aria-pressed]="isLanguageActive('he')"
              (click)="changeLanguage('he')"
            >
              {{ 'headerNav.language.he' | translate }}
            </button>
          </div> -->

          <button
            class="user-button"
            [class.user-open]="showUserMenu()"
            type="button"
            (click)="toggleUserMenu()"
          >
            <span class="user-name">{{ authService.userName() }}</span>
            <span class="avatar-circle" aria-hidden="true">
              <i class="pi pi-user"></i>
            </span>
          </button>

          @if (showUserMenu()) {
            <div class="user-menu-panel" role="menu">
              <div class="user-menu-header">
                <div class="user-menu-name">{{ authService.userName() }}</div>
                <div class="user-menu-email">{{ authService.user()?.email }}</div>
                <div class="user-menu-role">{{ userRoleLabel() }}</div>
              </div>

              @if (authService.hasPermissions(['admin:user-settings'])) {
                <div class="user-menu-divider"></div>

                <a
                  class="user-menu-item"
                  [routerLink]="AdminPaths.UserSettings"
                  (click)="closeMenus()"
                >
                  <svg
                    class="user-settings-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <line x1="21" y1="4" x2="14" y2="4"></line>
                    <line x1="10" y1="4" x2="3" y2="4"></line>
                    <line x1="21" y1="12" x2="12" y2="12"></line>
                    <line x1="8" y1="12" x2="3" y2="12"></line>
                    <line x1="21" y1="20" x2="16" y2="20"></line>
                    <line x1="12" y1="20" x2="3" y2="20"></line>
                    <line x1="14" y1="2" x2="14" y2="6"></line>
                    <line x1="8" y1="10" x2="8" y2="14"></line>
                    <line x1="16" y1="18" x2="16" y2="22"></line>
                  </svg>
                  <span>{{ 'headerNav.userSettings' | translate }}</span>
                </a>

                <div class="user-menu-divider"></div>
              }

              <button
                class="user-menu-item user-menu-item-danger"
                type="button"
                (click)="logout(); closeMenus()"
              >
                <i class="pi pi-sign-out"></i>
                <span>{{ 'headerNav.logout' | translate }}</span>
              </button>
            </div>
          }
        </div>
      }
    </div>
  </div>
</header>
